import React from 'react'
import { transformRegionToMap } from '@utils/pageUtils'
import HotSpotCanvas from '@organisms/HotSpotCanvas/HotSpotCanvas'
import {
  HotSpotCanvasWrapperProps,
  HotSpotBubbleWrapperProps
} from './HotSpotWrapperTypes'
import HotSpotBubble from '@atoms/HotSpotBubble/HotSpotBubble'

export const HotSpotCanvasWrapper = ({
  custom,
  data,
  regions
}: HotSpotCanvasWrapperProps) => {
  const bubbles = transformRegionToMap(regions).get('bubbles')
  const imageSrc = custom?.content?.image?.path
  return (
    <HotSpotCanvas
      bgImage={imageSrc}
      headline={data?.headline}
      bgColor={data?.bgColor}
      imageAlt={data?.imageAlt}
      // TODO: fix meta_data for all images from PD, maybe add default value there
      canvasSize={data?.image?.meta_data || { width: 500, height: 500 }}
      regions={bubbles}
    />
  )
}

export const HotSpotBubbleWrapper = ({
  activeIndex = 0,
  data,
  imageDimensions,
  index = 0,
  onBubbleSelect,
  regions
}: HotSpotBubbleWrapperProps) => {
  const content = transformRegionToMap(regions).get('content')

  const isActive = activeIndex === index
  const xPosition = (
    ((data?.xPosition ?? 0) / imageDimensions.width) *
    100
  ).toFixed(2)
  const yPosition = (
    ((data?.yPosition ?? 0) / imageDimensions.height) *
    100
  ).toFixed(2)

  return (
    <HotSpotBubble
      content={content}
      headline={data?.headline}
      index={index}
      isActive={isActive}
      link={data?.link}
      onSelect={onBubbleSelect}
      xPosition={xPosition}
      yPosition={yPosition}
    />
  )
}
